import React from "react";

const CardTransaction = () => (
  <svg
    width="17"
    height="14"
    viewBox="0 0 17 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 7C1 4.17175 1 2.75725 1.879 1.879C2.758 1.00075 4.17175 1 7 1H10C12.8283 1 14.2428 1 15.121 1.879C15.9993 2.758 16 4.17175 16 7C16 9.82825 16 11.2428 15.121 12.121C14.242 12.9993 12.8283 13 10 13H7C4.17175 13 2.75725 13 1.879 12.121C1.00075 11.242 1 9.82825 1 7Z"
      stroke="#387CFF"
      strokeWidth="1.5"
    />
    <path
      d="M7 10H4M10 10H8.875M1 5.5H16"
      stroke="#387CFF"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
  </svg>
);

export default CardTransaction;
